import AppConstant from '../../../../../config/app.constants';
import BaseController from '../common/environment_config.base.controller'

class EnvironmentConfigAllController extends BaseController {
    /*@ngInject*/
    constructor(Auth, $state, User, EnvironmentConfigService, Modal, $translate, $location, $stateParams, CommonLayoutService, Configs, Idle) {
        super(Auth, $state, User, EnvironmentConfigService, Modal, $translate)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.Modal = Modal;
        this.$location = $location;
        this.$stateParams = $stateParams;
        this.CommonLayoutService = CommonLayoutService;
        this.Configs = Configs;
        this.page = 1;
        this.Idle = Idle;
        this.permissionErrors = {};

        this.defaultModel = {
            currentBranch: this.User.getUser().branchId,
            otcConfig: [],
            googleMapFrontEndKey: null,
            googleMapBackEndKey: null,
            ETADistanceKey: null,
            routificApiKey: null,
            enableRoutific: false,
            pageTitle: null,
            webUrl: null,
            companyName: null,
            companyLogo: [],
            printLogo: [],
            selectedFiles: [],
            printFromLocationName: null,
            printFromLocationAddress: null,
            printLogoMetaData: {},
            companyLogoMetaData: {},
            generateXMLFile: false,
            generateCSVFile: false,
            communicationPassword: null,
            cryptographyPassword: null,
            masterPassword: null,
            OTCUserSync: false,
            enable2FA: false,
            maintainDriveDistance: false,
            companyAddress: null,
            companyPhoneNumber: null,
            companyEmail: null,
            footerText: null,
            atmCodesPermission: {},
            settingsPermission: {},
            tntBypassCodePermission: {},
            environmentConfigPermission: {},
            vaultOperationsPermission:{},
            userEditPermission: {},
            bulkCashPermission: {},
            noSessionExpirationPermission: {},
            softDeleteShipmentPermission: {},
            changeVaultDatePermission: {},
            automatedRoutingControlPermission: {},
            bulkUpdateUserPermission: {},
            enableRouteProgressTracking: false,
            sessionLength: null,
            autoReassign: false,
            routeOptimizationEngine: null,
            autoCreatePackableShipment: false,
            autoAssignServiceTickets: false,
            fuelRateImportConfig: {},
            bagOutScanLimit: null,
            promptBluetoothScanner: false
        }
        this.model = angular.copy(this.defaultModel)

        this.toggleSwitchUI = {
            size: 'small',
            label: {
                on: this.$translate.instant('common.yes'),
                off: this.$translate.instant('common.no'),
            },
            onColor: 'success',
            offColor: 'danger'
        };

        this.routeOptimizationEngine = [
            { value: 'routific', label: 'Routific' },
            { value: 'google_maps', label: 'Google Maps' }
        ];

        this.passWdIcon = {};
		this.passwordStats = ['NFC', 'OTC'];
        this.stats = {
            active: 'active',
            suspended: 'suspended'
        }
    }

    $onInit() {
        let pageId = this.$stateParams.page
        if (pageId > 0) {
            this.page = pageId;
        }
        this.passwordStats.forEach((stat) => {
            if (stat === 'OTC') this.passWdIcon[stat] = {};
        })
        this.loadData();
    }

    refresh() {
        this.loadData();
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.permissionErrors = {};
    }

    loadData() {
        this.loading = true;
        this.permissionErrors = {};

        this.model.otcConfig = [];
        this.Service.details()
            .then((data) => {
                this.environmentConfig = data.results;
                if (!this.environmentConfig) return;

                const otcConfig = this.environmentConfig.OTCAnywhere;
                if (!_.isEmpty(otcConfig)) {
                    const otcCompanyName = Object.keys(this.environmentConfig.OTCAnywhere);

                    otcCompanyName.forEach((company) => {
                        // this.setPasswordMap(null, company);
                        this.passwordStats.forEach((stat) => {
                            if (stat === 'NFC') this.passWdIcon[stat] = { communicationPassword: false, cryptographyPassword: false, masterPassword: null };
                            if (stat === 'OTC') {
                                this.passWdIcon[stat][company] = { viewPass: false };
                            }
                        })

                        this.model.otcConfig.push({
                            companyName: otcConfig[company].company,
                            user: otcConfig[company].user,
                            password: otcConfig[company].passwd,
                            secure: otcConfig[company].options ? otcConfig[company].options.secure : null,
                            hostName: otcConfig[company].options ? otcConfig[company].options.hostname : null,
                            disableLockStatus: otcConfig[company].disableLockStatus
                        })
                    });
                }

                this.model.googleMapBackEndKey = this.environmentConfig.googleMapKeys && this.environmentConfig.googleMapKeys.maps ? this.environmentConfig.googleMapKeys.maps.backend.key : null;
                this.model.googleMapFrontEndKey = this.environmentConfig.googleMapKeys && this.environmentConfig.googleMapKeys.maps ? this.environmentConfig.googleMapKeys.maps.frontend.key : null;
                this.model.ETADistanceKey = this.environmentConfig.googleMapKeys && this.environmentConfig.googleMapKeys.maps && this.environmentConfig.googleMapKeys.maps.ETADistanceKey && this.environmentConfig.googleMapKeys.maps.ETADistanceKey.key ? this.environmentConfig.googleMapKeys.maps.ETADistanceKey.key : null;
                this.model.enableRoutific = this.environmentConfig.routific ? this.environmentConfig.routific.enable : null;
                this.model.routificApiKey = this.environmentConfig.routific ? this.environmentConfig.routific.token : null;
                this.model.pageTitle = this.environmentConfig.assets ? this.environmentConfig.assets.pageTitle : null;
                this.model.companyName = this.environmentConfig.assets ? this.environmentConfig.assets.companyName : null;
                this.model.printFromLocationName = this.environmentConfig.assets ? this.environmentConfig.assets.printFromLocationName : null;
                this.model.printFromLocationAddress = this.environmentConfig.assets ? this.environmentConfig.assets.printFromLocationAddress : null;
                this.model.companyLogo = this.environmentConfig.companyLogo ? this.environmentConfig.companyLogo.data : null;
                this.model.printLogo = this.environmentConfig.printLogo ? this.environmentConfig.printLogo.data : null;
                this.model.printLogoMetaData = this.environmentConfig.printLogoMetaData
                this.model.companyLogoMetaData = this.environmentConfig.companyLogoMetaData;
                this.model.generateXMLFile = this.environmentConfig.bagoutManifestConfig ? this.environmentConfig.bagoutManifestConfig.generateXMLFile : false;
                this.model.generateCSVFile = this.environmentConfig.bagoutManifestConfig ? this.environmentConfig.bagoutManifestConfig.generateCSVFile : false;
                this.model.bagOutScanLimit = this.environmentConfig.bagoutManifestConfig ? this.environmentConfig.bagoutManifestConfig.bagOutScanLimit : null;
                this.model.communicationPassword = this.environmentConfig.NFCConfig ? this.environmentConfig.NFCConfig.communicationPassword: null;
                this.model.cryptographyPassword = this.environmentConfig.NFCConfig ? this.environmentConfig.NFCConfig.cryptographyPassword: null;
                this.model.masterPassword = this.environmentConfig.NFCConfig ? this.environmentConfig.NFCConfig.masterPassword: null;
                this.model.OTCUserSync = this.environmentConfig.cronSchedulerConfig && this.environmentConfig.cronSchedulerConfig.OTCUserSync ? this.environmentConfig.cronSchedulerConfig.OTCUserSync : false;
                this.model.enable2FA = this.environmentConfig.enable2FA;
                this.model.maintainDriveDistance = this.environmentConfig.googleMapKeys && this.environmentConfig.googleMapKeys.maps && 
                                                   this.environmentConfig.googleMapKeys.maps.hasOwnProperty('maintainDriveDistance') ?
                                                   this.environmentConfig.googleMapKeys.maps.maintainDriveDistance : false;
                this.model.companyAddress = this.environmentConfig.assets ? this.environmentConfig.assets.companyAddress : null;
                this.model.companyPhoneNumber = this.environmentConfig.assets ? this.environmentConfig.assets.companyPhoneNumber : null;
                this.model.companyEmail = this.environmentConfig.assets ? this.environmentConfig.assets.companyEmail : null;
                this.model.footerText = this.environmentConfig.assets ? this.environmentConfig.assets.footerText : null;
                this.model.paths = this.environmentConfig.paths;
                this.model.atmCodesPermission = this.environmentConfig.permissions && this.environmentConfig.permissions.atmCodes ? this.environmentConfig.permissions.atmCodes.users : null;
                this.model.settingsPermission = this.environmentConfig.permissions && this.environmentConfig.permissions.settings ? this.environmentConfig.permissions.settings.users : null;
                this.model.tntBypassCodePermission = this.environmentConfig.permissions && this.environmentConfig.permissions.tntBypassCode ? this.environmentConfig.permissions.tntBypassCode.users : null;
                this.model.environmentConfigPermission = this.environmentConfig.permissions && this.environmentConfig.permissions.environmentConfig ? this.environmentConfig.permissions.environmentConfig.users : null;
                this.model.vaultOperationsPermission = this.environmentConfig.permissions && this.environmentConfig.permissions.valutOprations ? this.environmentConfig.permissions.valutOprations.users : null;
                this.model.userEditPermission = this.environmentConfig.permissions && this.environmentConfig.permissions.userEdit ? this.environmentConfig.permissions.userEdit.users : null;
                this.model.bulkCashPermission = this.environmentConfig.permissions && this.environmentConfig.permissions.bulkCash ? this.environmentConfig.permissions.bulkCash.users : null;
                this.model.noSessionExpirationPermission = this.environmentConfig.permissions && this.environmentConfig.permissions.noSessionExpiration ? this.environmentConfig.permissions.noSessionExpiration.users : null;
                this.model.softDeleteShipmentPermission =  this.environmentConfig.permissions && this.environmentConfig.permissions.softDeleteShipment ? this.environmentConfig.permissions.softDeleteShipment.users : null;
                this.model.changeVaultDatePermission = this.environmentConfig.permissions && this.environmentConfig.permissions.changeVaultDate ? this.environmentConfig.permissions.changeVaultDate.users : null;
                this.model.automatedRoutingControlPermission = this.environmentConfig.permissions && this.environmentConfig.permissions.automatedRoutingControl ? this.environmentConfig.permissions.automatedRoutingControl.users : null;
                this.model.bulkUpdateUserPermission = this.environmentConfig.permissions && this.environmentConfig.permissions.bulkUpdateUser ? this.environmentConfig.permissions.bulkUpdateUser.users : null;
                this.model.enableRouteProgressTracking = this.environmentConfig.enableRouteProgressTracking;
                this.model.autoReassign = this.environmentConfig.autoReassign;
                this.model.sessionLength = this.environmentConfig.sessionLength;
                this.model.routeOptimizationEngine = this.environmentConfig.routeOptimizationEngine;
                this.model.autoCreatePackableShipment = this.environmentConfig.cronSchedulerConfig && this.environmentConfig.cronSchedulerConfig.autoCreatePackableShipment ? this.environmentConfig.cronSchedulerConfig.autoCreatePackableShipment : false;
                this.model.autoAssignServiceTickets = this.environmentConfig.cronSchedulerConfig && this.environmentConfig.cronSchedulerConfig.autoAssignServiceTickets ? this.environmentConfig.cronSchedulerConfig.autoAssignServiceTickets : false;
                this.model.fuelRateImportStatus = this.environmentConfig.fuelRateImportConfig && this.environmentConfig.fuelRateImportConfig.status ? this.environmentConfig.fuelRateImportConfig.status : 'suspended';
                this.model.fuelRateImportDataURL = this.environmentConfig.fuelRateImportConfig && this.environmentConfig.fuelRateImportConfig.url ? this.environmentConfig.fuelRateImportConfig.url : null;
                this.model.promptBluetoothScanner = this.environmentConfig.promptBluetoothScanner;

                this.rawId = this.environmentConfig.id;
                this.defaultModel = this.model;
                this.model = angular.copy(this.defaultModel);
                this.CommonLayoutService.setUIConfig(this.environmentConfig.assets);

                if (this.model.companyLogo && this.model.companyLogo.length) {
                    const companyLogoObjectURL = this.CommonLayoutService.generateObjectURL(this.model.companyLogo);
                    document.getElementById('navbar_company_logo').src = companyLogoObjectURL;
                    this.CommonLayoutService.updateFavicon(this.model.companyLogo);
                }
                this.Configs.setEnvironmentConfig(this.environmentConfig);
                this.validatePermissions();
            })
            .catch((err) => {
                console.log(err);
                if (err && err.data && err.data.errors) {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                }
                else {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.loading = false;
            })
    }

    setPasswordMap(stat, type) {
        if (stat === 'OTC') {
            this.passWdIcon[stat][type] = { viewPass: false };
        }
    }

    // showPassword(type, company) {
    //     this.passWdIcon[company].viewPass = !this.passWdIcon[company].viewPass;
    // }

    update() {
        if (!this.validatePermissions()) {
            return;
        }

        let OtcConfig = {}, googleMapConfig = { maps: {} }, routific = {}, assets = {}, companyLogo = [], printLogo = [], 
            bagoutManifestConfig = {}, NFCConfig = {}, cronSchedulerConfig = {}, permissions = {}, fuelRateImportConfig = {};

        this.isUpdating = true;
        this.model.otcConfig.forEach((otc) => {
            OtcConfig = Object.assign(OtcConfig, {
                [otc.companyName]: {
                    company: otc.companyName,
                    user: otc.user,
                    passwd: otc.password,
                    disableLockStatus: otc.disableLockStatus,
                    options: {
                        secure: otc.secure,
                        hostname: otc.hostName
                    }
                },
            })
        })

        googleMapConfig.maps = {
            backend: {
                key: this.model.googleMapBackEndKey
            },
            frontend: {
                key: this.model.googleMapFrontEndKey
            },
            maintainDriveDistance: this.model.maintainDriveDistance,
            ETADistanceKey: {
                key: this.model.ETADistanceKey
            }
        }

        routific = {
            enable: this.model.enableRoutific,
            token: this.model.routificApiKey
        }

        assets = {
            pageTitle: this.model.pageTitle,
            companyName: this.model.companyName,
            printFromLocationName: this.model.printFromLocationName,
            printFromLocationAddress: this.model.printFromLocationAddress,
            companyAddress: this.model.companyAddress,
            companyPhoneNumber: this.model.companyPhoneNumber,
            companyEmail: this.model.companyEmail,
            footerText: this.model.footerText
        }

        bagoutManifestConfig = {
            generateXMLFile: this.model.generateXMLFile,
            generateCSVFile: this.model.generateCSVFile,
            bagOutScanLimit: this.model.bagOutScanLimit
        }

        NFCConfig = {
            communicationPassword: this.model.communicationPassword,
            cryptographyPassword: this.model.cryptographyPassword,
            masterPassword: this.model.masterPassword
        }

        cronSchedulerConfig = {
            OTCUserSync: this.model.OTCUserSync,
            autoCreatePackableShipment: this.model.autoCreatePackableShipment,
            autoAssignServiceTickets: this.model.autoAssignServiceTickets
        }

        permissions = {
            atmCodes: { users: this.model.atmCodesPermission },
            settings: { users: this.model.settingsPermission },
            tntBypassCode: { users: this.model.tntBypassCodePermission },
            environmentConfig: { users: this.model.environmentConfigPermission },
            valutOprations: { users: this.model.vaultOperationsPermission },
            userEdit: { users: this.model.userEditPermission },
            bulkCash: { users: this.model.bulkCashPermission },
            noSessionExpiration: { users: this.model.noSessionExpiration },
            softDeleteShipment: { users: this.model.softDeleteShipmentPermission },
            changeVaultDate: { users: this.model.changeVaultDatePermission },
            automatedRoutingControl: { users: this.model.automatedRoutingControlPermission },
            bulkUpdateUser: { users: this.model.bulkUpdateUserPermission }
        }

        fuelRateImportConfig = {
            url: this.model.fuelRateImportDataURL,
            status: this.model.fuelRateImportStatus
        }

        if (this.model.companyLogo && this.model.companyLogo.length && this.model.companyLogo[0].hasOwnProperty('base64Data')) {
            this.model.companyLogo.forEach((d) => {
                this.model.companyLogoMetaData = {
                    lastModified: d._file.lastModified,
                    lastModifiedDate: d._file.lastModifiedDate,
                    name: d._file.name,
                    size: d._file.size,
                    type: d._file.type,
                }
                companyLogo.push({ base64String: d.base64Data, fileName: d.fileName });
            })
        }

        if (this.model.printLogo && this.model.printLogo.length && this.model.printLogo[0].hasOwnProperty('base64Data')) {
            this.model.printLogo.forEach((d) => {
                this.model.printLogoMetaData = {
                    lastModified: d._file.lastModified,
                    lastModifiedDate: d._file.lastModifiedDate,
                    name: d._file.name,
                    size: d._file.size,
                    type: d._file.type,
                }
                printLogo.push({ base64String: d.base64Data, fileName: d.fileName });
            })
        }
        const payload = {
            OTCAnywhere: OtcConfig,
            googleMapKeys: googleMapConfig,
            routific,
            assets,
            companyLogo,
            companyLogoMetaData: this.model.companyLogoMetaData,
            printLogo,
            printLogoMetaData: this.model.printLogoMetaData,
            printFromLocationName: this.model.printFromLocationName,
            printFromLocationAddress: this.model.printFromLocationAddress,
            id: this.rawId,
            branchId: this.model.currentBranch,
            bagoutManifestConfig,
            NFCConfig,
            cronSchedulerConfig,
            enable2FA: this.model.enable2FA,
            permissions,
            enableRouteProgressTracking: this.model.enableRouteProgressTracking,
            sessionLength: this.model.sessionLength,
            autoReassign: this.model.autoReassign,
            routeOptimizationEngine: this.model.routeOptimizationEngine,
            fuelRateImportConfig,
            promptBluetoothScanner: this.model.promptBluetoothScanner
        };

        let envConfClone = Object.assign({}, this.environmentConfig);

        delete envConfClone.createdAt
        delete envConfClone.updatedAt
        delete envConfClone.printLogo
        delete envConfClone.companyLogo
        envConfClone.branchId = this.model.currentBranch;
        envConfClone.printFromLocationAddress = this.environmentConfig.assets.printFromLocationAddress;
        envConfClone.printFromLocationName = this.environmentConfig.assets.printFromLocationName;
        let payloadClone = Object.assign({}, payload);
        payloadClone.paths = this.environmentConfig.paths;
        delete payloadClone.printLogo;
        delete payloadClone.companyLogo;
        payloadClone.printFromLocationAddress = payload.assets.printFromLocationAddress;
        payloadClone.printFromLocationName = payload.assets.printFromLocationName;
        const changeValues = this.diffObjects(envConfClone, payloadClone)
        const userId = this.User.getUser().id;
        this.Service.update({...payload, changedObj: changeValues, modifiedByUserId: userId})
            .then(() => {
                this.loadData();
                if(this.model.sessionLength){
                    this.Idle.watch()
                    this.Idle.setIdle(this.model.sessionLength * 60);
                    localStorage.setItem('sessionLength', JSON.stringify(this.model.sessionLength))
                } else {
                    this.Idle.unwatch()
                    localStorage.removeItem('sessionLength')
                }
            })
            .catch((err) => {
                if (err && err.data && err.data.errors) {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                }
                else if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
                else {
                    console.log(err);
                }
            })
            .finally(() => {
                this.isUpdating = false;
            })
    }

    addOTCConfig() {
        this.model.otcConfig.push({
            companyName: null,
            user: null,
            password: null,
            secure: true,
            hostName: null,
            disableLockStatus: false
        });
        this.validateOTCConfig();
    }

    removeOTCConfig(index) {
        this.model.otcConfig.splice(index, 1);
        this.validateOTCConfig();
    }

    validateOTCConfig() {
        this.model.otcConfig = _.map(this.model.otcConfig, (obj, index) => {
            obj.isDuplicate = false;
            let match = _.find(this.model.otcConfig, (compairObject, compairObjIndex) => {
                if (index > compairObjIndex) return compairObject.companyName == obj.companyName;
            });
            if (match) {
                obj.isDuplicate = true;
                return obj;
            } else {
                return obj;
            }
        });
        let isValidDirective = this.model.otcConfig.map((obj) => {
            if (obj.isDuplicate) return true;
        })
        this.isValid = isValidDirective.indexOf(true) >= 0 ? false : true;
    }

    validatePermissions() {
        const permissionFields = [
            'atmCodesPermission',
            'settingsPermission',
            'tntBypassCodePermission',
            'environmentConfigPermission',
            'vaultOperationsPermission',
            'bulkCashPermission',
            'userEditPermission',
            'softDeleteShipmentPermission',
            'changeVaultDatePermission',
            'automatedRoutingControlPermission',
            'bulkUpdateUserPermission'
        ];

        this.permissionErrors = {};
        let hasDuplicates = false;

        permissionFields.forEach(field => {
            const value = this.model[field];
            if (value && typeof value === 'string') {
                const users = value.split(',').map(u => u.trim()).filter(u => u);
                const uniqueUsers = new Set(users);

                if (users.length !== uniqueUsers.size) {
                    const duplicateUser = users.find((user, index) => {
                        return users.indexOf(user) !== index;
                    });
                    this.permissionErrors[field] = this.$translate.instant(
                        'environmentConfig.duplicate_users_not_allowed_message',
                        { user: duplicateUser }
                    );
                    hasDuplicates = true;
                } else {
                    this.permissionErrors[field] = null;
                }
            } else {
                this.permissionErrors[field] = null;
            }
        });

        return !hasDuplicates;
    }

    hasPermissionErrors() {
        return Object.values(this.permissionErrors).some(error => error !== null);
    }

    viewAppLogo(data, stat) {
        this.Modal.viewAppLogo(data, stat, ({ modal }) => {
        }, ({ modal }) => {
            modal.close();
        });
    }

    viewPassword(stat, type, field) {
        this.CommonLayoutService.viewPassword(stat, type, field, this.passWdIcon);
	}

    isValidLength() {
        if(this.model.sessionLength === null) return true;
        // Check if the value is undefined or null
        if (this.model.sessionLength === undefined) {
          return false;
        }
      
        // Convert the value to a number and check if it's a valid number
        const sessionLength = Number(this.model.sessionLength);
        if (isNaN(sessionLength) || sessionLength < 1) {
          return false;
        }
      
        // Check if the value is a positive integer
        return /^[1-9]\d*$/.test(this.model.sessionLength.toString());
      }
    
    diffObjects(obj1, obj2) {
        const diff = {};
      
        // Iterate through the keys in obj1
        for (const key in obj1) {
          // If the key doesn't exist in obj2, add it to the diff object
          if (!(key in obj2)) {
            diff[key] = { "Old Value": obj1[key], "Updated Value": undefined };
          } else {
            // If the value is an object, recursively compare them
            if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
              const nestedDiff = this.diffObjects(obj1[key], obj2[key]);
              if (Object.keys(nestedDiff).length > 0) {
                diff[key] = nestedDiff;
              }
            } else if (obj1[key] !== obj2[key]) {
              diff[key] = { "Old Value": obj1[key], "Updated Value": obj2[key] };
            }
          }
        }
      
        // Iterate through the keys in obj2 that are not in obj1
        for (const key in obj2) {
          if (!(key in obj1)) {
            diff[key] = { "Old Value": undefined, "Updated Value": obj2[key] };
          }
        }
      
        return diff;
    }

    tabSelection(selectedValue) {
        this.model.fuelRateImportStatus = selectedValue;
    }

}

export default EnvironmentConfigAllController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/environment_config/all/environment_config.all.controller.js